/**
 * Interpola entre duas cores em hexadecimal, baseado no valor e valor máximo.
 * Útil para gradientes de calor.
 */
export function interpolateColors({
  endColor = '#F02B2B',
  maxValue,
  startColor = '#ed942f',
  value,
}) {
  // Calcula o fator de interpolação
  const factor = maxValue ? value / maxValue : 0

  // Converte número para hexadecimal
  const hex = (x: number) => x.toString(16).padStart(2, '0')
  // Converte cor hexadecimal para array RGB
  const toRGB = (hexColor: string) => [
    parseInt(hexColor.slice(1, 3), 16),
    parseInt(hexColor.slice(3, 5), 16),
    parseInt(hexColor.slice(5, 7), 16),
  ]

  const [r1, g1, b1] = toRGB(startColor)
  const [r2, g2, b2] = toRGB(endColor)

  // Interpola cada canal de cor
  const r = Math.floor(r1 + factor * (r2 - r1))
  const g = Math.floor(g1 + factor * (g2 - g1))
  const b = Math.floor(b1 + factor * (b2 - b1))

  return `#${hex(r)}${hex(g)}${hex(b)}`
}
